import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { SIZE_CHART } from "@/lib/i18n";
import { imgUrl } from "@/lib/api";

const SizeGuide = ({ open, onOpenChange, category }) => {
  const { t, lang } = useLang();
  const content = useContent();
  const sg = ((content?.size_guides && category && content.size_guides[category]) || content?.size_guide || {});
  const image = sg.image ? imgUrl(sg.image) : "";
  const note = lang === "ro" ? sg.note_ro : sg.note_en;
  const desc = (lang === "ro" ? sg.desc_ro : sg.desc_en) || t.sizeGuideModal.desc;
  const hasCustom = Array.isArray(sg.rows) && sg.rows.length > 0;
  const cols = hasCustom && sg.cols && sg.cols.length ? sg.cols : t.sizeGuideModal.cols;
  const rows = hasCustom ? sg.rows : SIZE_CHART;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-none border border-border bg-background p-0" data-testid="size-guide-modal">
        <DialogHeader className="border-b border-border p-6">
          <DialogTitle className="text-2xl font-black uppercase tracking-tight">
            {t.sizeGuideModal.title}
          </DialogTitle>
          <DialogDescription className="mt-1 font-mono text-xs uppercase tracking-widest text-muted-foreground">
            {desc}
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[70vh] overflow-y-auto p-6">
          {image && (
            <img src={image} alt="Size guide" className="mb-4 w-full border border-border object-contain" data-testid="size-guide-image" />
          )}
          <table className="w-full border-collapse font-mono text-sm" data-testid="size-guide-table">
              <thead>
                <tr>
                  {cols.map((c, i) => (
                    <th key={i} className="border border-border p-2 text-left text-xs uppercase tracking-widest">{c}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, ri) => (
                  <tr key={ri}>
                    {row.map((cell, i) => (
                      <td key={i} className="border border-border p-2">{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          {note ? <p className="mt-4 whitespace-pre-line text-sm leading-relaxed text-muted-foreground" data-testid="size-guide-note">{note}</p> : null}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SizeGuide;
